/** Lightweight client-side validators. Server is the source of truth;
 *  these prevent obvious 4xx round-trips. */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const E164_RE = /^\+[1-9]\d{6,14}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isUuid = (v: string): boolean => UUID_RE.test(v.trim());
export const isE164Phone = (v: string): boolean => E164_RE.test(v.trim());
export const isLikelyEmail = (v: string): boolean => EMAIL_RE.test(v.trim());

/** True if the string can plausibly become a non-zero positive amount. */
export const isPositiveAmount = (v: string): boolean => {
  const n = Number.parseFloat(v.trim());
  return Number.isFinite(n) && n > 0;
};
